module.exports = __webpack_public_path__ + "img/avbuilder_bluesend.5fed7a18.svg";